import { useUser } from "../hooks/useUser";
import "../ui/styles/adminBoard.css";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../ui/uiElements/Sidebar.component";

function AdminBoard() {
  const navigate = useNavigate();

  const { isAdminAuthenticated } = useUser();

  if (isAdminAuthenticated === false) navigate("/home");

  return (
    <div className="board-container">
      <Sidebar title="Dashboard">
        <ul className="navigation-list">
          <li>
            <NavLink to="/admin/users" className="styled-nav-link">
              Users
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/registrationRequests" className="styled-nav-link">
              Registration requests
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/invitation" className="styled-nav-link">
              Invite member
            </NavLink>
          </li>
        </ul>
      </Sidebar>
      <div className="bg-light content-board">
        <Outlet />
      </div>
    </div>
  );
}

export default AdminBoard;
